import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Banner from './pages/Banner';
import Dashboard from './pages/Dashboard';
import Category from './pages/Category';
import SubCategory from './pages/SubCategory';
import MainLayout from './components/MainLayout';
import LoginPage from './pages/LoginPage';
import PermissionsAdmin from './pages/PermissionsAdmin';
import RolesAdmin from './pages/RolesAdmin';
import AdminProducts from './pages/AddProducts';
import ProductImages from './pages/ProductImages';
import AllUsersAdminPage from './pages/AllUsersAdminPage';
import ProductVideoUpload from './pages/AddProductVideo';
import ProductOverviewSale from './pages/ProductOverView';
import AddProductTag from './pages/AddProductTag';
import ProductOverviewIcons from './pages/ProductOverviewIcons';
import AdminTourInPersonPage from './pages/TourInPerson';
import AdminTourViaVideoChatPage from './pages/AdminTourViaVideoChatPage';
import AdminHomeForm from './pages/AdminHome';
import ApartmentByCity from './pages/ApartmentByCity';
import RentByCity from './pages/RentByCity';
import JobManagement from './pages/JobManagement';
import ApplyJob from './pages/ApplyJob';
import AllJobs from './pages/AllJobs';
import JobAlert from './pages/JobAlert';
import Community from './pages/Community';
import ApprovedJobAdmin from './pages/ApprovedJobAdmin';
import SellerProduct from './pages/SellerProduct';
import QuestionsManager from './pages/AddQuestions';
import WhatsNew from './pages/WhatsNew';
import Headlines from './pages/Headlines';
import BlogManager from './pages/AddBlogs';
import AdminFAQs from './pages/AdminFaqs';
import AdminExecutiveLeaders from './pages/ExcectiveLeaders';
import AdminSuccessStories from './pages/SuccessStoriesManager';
import UpcomingEvents from './pages/UpcomingEvents';
import UpcomingEventsRegister from './pages/RegistredEventsAlert';
import AddNewproduct from './pages/AddNewproduct';
import AdminRoles from './pages/AdminRoles';

function App() {
    return (
        <Router>
            <Routes>
                {/* Root path for login */}
                <Route path='/' element={<LoginPage />} />

                {/* Admin layout with nested routes */}
                <Route path='admin' element={<MainLayout />}>
                    {/* Child routes should have relative paths */}
                    <Route index element={<Dashboard />} /> {/* This makes Dashboard the default for /admin */}
                    <Route path='add-category-manager' element={<Category />} />
                    <Route path='main-sub-category' element={<SubCategory />} />
                    <Route path='Banner-Manager' element={<Banner />} />
                    <Route path='Add-Permission' element={<PermissionsAdmin />} />
                    <Route path='Add-Roles' element={<RolesAdmin />} />
                    <Route path='Add-Products' element={<AdminProducts />} />
                    <Route path='Products-Images' element={<ProductImages />} />
                    <Route path='All-Users' element={<AllUsersAdminPage />} />
                    <Route path='Upload-Video' element={<ProductVideoUpload />} />
                    <Route path='Add-Product-OverView' element={<ProductOverviewSale />} />
                    <Route path='Add-Products-tags' element={<AddProductTag />} />
                    <Route path='Add-Product-Icons' element={<ProductOverviewIcons />} />
                    <Route path='Tour-In-Person' element={<AdminTourInPersonPage />} />
                    <Route path='Tour-Via-VideoChat' element={<AdminTourViaVideoChatPage />} />
                    <Route path="Add-Home-Locations" element={<AdminHomeForm />} />
                    <Route path='Add-Appartements' element={<ApartmentByCity />} />
                    <Route path='Rent-House' element={<RentByCity />} />
                    <Route path='Create-Jobs' element={<JobManagement />} />
                    <Route path='ApplyJob' element={<ApplyJob />} />
                    <Route path='AllJob' element={<AllJobs />} />
                    <Route path='JobAlert' element={<JobAlert />} />
                    <Route path='Community' element={<Community />} />
                    <Route path='ApprovedJobAdmin' element={<ApprovedJobAdmin />} />
                    <Route path='SellerProduct' element={<SellerProduct />} />
                    <Route path='Add-Questions' element={<QuestionsManager />} />
                    <Route path='Add-Blogs' element={<BlogManager />} />
                    <Route path='Create-Faqs' element={<AdminFAQs />} />
                    <Route path='Success-Stories' element={<AdminExecutiveLeaders />} />
                    <Route path='Success-Story-Manager' element={<AdminSuccessStories />} />
                    <Route path='UpComming-Events' element={<UpcomingEvents />} />
                    <Route path='Registered-Event-Req' element={<UpcomingEvents />} />
                    <Route path='AddNewproduct' element={<AddNewproduct />} />
                    <Route path='whats-new' element={<WhatsNew />} />
                    <Route path='Headlines' element={<Headlines />} />
                    <Route path="All-Roles" element={<AdminRoles />} />
                </Route>
            </Routes>
        </Router >
    );
}

export default App;
